// extracted by mini-css-extract-plugin
export default {"voidImgWrapper":"voidImgWrapper--spj1m","voidImg":"voidImg--aJ7et","voidText":"voidText--MAwQM"};